import { z } from "zod";

export const contactSchema = z
  .object({
     firstName: z
      .string()
      .trim()
      .min(1, "First name is required")
      .max(50, "First name must not exceed 50 characters")
      .regex(/^[A-Za-z]+(?: [A-Za-z]+)*$/, "First name can only contain letters and spaces"),

    lastName: z
      .string()
      .trim()
      .min(1, "Last name is required")
      .max(50, "Last name must not exceed 50 characters")
      .regex(/^[A-Za-z]+(?: [A-Za-z]+)*$/, "Last name can only contain letters and spaces"),

    email: z
      .string()
      .min(1, "Please enter an email address.")
      .email("Please enter a valid email address."),

    countryCode: z.string().min(1, "Please select a country code."),

    contactMobileNo: z
      .string()
      .min(7, "Please enter the valid contact number.")
      .max(15, "Contact number must not exceed 15 characters.")
      .regex(/^[0-9]+$/, "Please enter a valid contact number."),
  })
  .superRefine((data, ctx) => {
    if (data.countryCode === "+60") {
      const phone = data.contactMobileNo;

      // Malaysia mobile number must be exactly 9 digits
      if ((phone.length !== 9 && phone.length !== 10)) {
        ctx.addIssue({
          code: "custom",
          path: ["contactMobileNo"],
          message: "Enter a valid Malaysian mobile number (e.g. 123456789)",
        });
      }

      // Cannot start with 0
      if (phone.startsWith("0")) {
        ctx.addIssue({
          code: "custom",
          path: ["contactMobileNo"],
          message: "Enter a valid Malaysian mobile number (e.g. 123456789)",
        });
      }
    }
  });

export type ContactValues = z.infer<typeof contactSchema>;